import { render, staticRenderFns } from "./SexSelect.vue?vue&type=template&id=37348671&"
import script from "./SexSelect.vue?vue&type=script&lang=ts&"
export * from "./SexSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports